(() => {
  const initialize = root => {
    root.querySelectorAll('[data-contact-topic]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      const form = select.closest('form');
      const help = form?.querySelector('[data-contact-topic-help]');
      const topic = new URLSearchParams(window.location.search).get('topic');
      const option = [...select.options].find(item => item.dataset.topic === topic);
      if (option && !form?.querySelector('[role="alert"]')) select.value = option.value;
      const update = () => {
        if (!help) return;
        const selectedTopic = select.selectedOptions[0]?.dataset.topic;
        help.textContent = selectedTopic === 'order' ? help.dataset.orderHelp : selectedTopic === 'subscription' ? help.dataset.subscriptionHelp : '';
        help.hidden = !help.textContent;
      };
      select.addEventListener('change', update);
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
